import {EXPOSE_TEST} from './action-types';
import {logExperiment} from '@homeaway/abacus-client-utils';

export function exposeTest(testname) {
    return (dispatch, getState) => {
        const {abacus = {}, mvt = {}} = getState();
        const {exposed = {}} = mvt;

        if (!testname) {
            return Promise.reject(new Error('testname not provided'));
        }

        if (abacus[testname] && !exposed[testname]) {
            logExperiment(abacus[testname]);
        }

        // Dispatch the action even if duplicated. This might change in the future.
        return dispatch({
            type: EXPOSE_TEST,
            testname
        });
    };
}
